import { Item } from './../../../../../shared/models/policies/policies.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';



/* Providers */
import { GenericRequestProvider } from '../../generic-request-provider';

@Injectable({
    providedIn: 'root'
})
export class CompliancePoliciesProvider  {
   
    constructor(
         private http: HttpClient
    ) {}

    list(): GenericRequestProvider<any> {
        return new GenericRequestProvider<any>(`api/politicacompliance`, this.http);
    }
    getId(): GenericRequestProvider<Item[]> {
        return new GenericRequestProvider<Item[]>(`api/politicacompliance`, this.http);
    }
    update(): GenericRequestProvider<Item> {
        return new GenericRequestProvider<Item>(`api/politicacompliance`, this.http); 
    }
    delete(): GenericRequestProvider<Item> {
        return new GenericRequestProvider<Item>(`api/politicacompliance`, this.http);
    }
    create(): GenericRequestProvider<Item> {
        return new GenericRequestProvider<Item>(`api/politicacompliance`, this.http);
    }
   
   
    
}
